import { Box, Icon, Text } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import { memo, useMemo } from 'react';
import { StatusPerkMessageProps } from './types';
import { formatCompact } from '@bonanza-social/toolkit/utils';

function StatusPerkMessage({
  perkType,
  currentStatusPerkAmount,
}: StatusPerkMessageProps) {
  const [t] = useTranslation('status');

  const perkMessageText = useMemo(() => {
    switch (perkType) {
      case 'AccessToBetterRaf':
      case 'MultiplierOnLevelUp':
      case 'ShopWeeklyPromotion':
      case 'Cashback':
        return currentStatusPerkAmount
          ? t(`perkMessage${perkType}`, { amount: currentStatusPerkAmount })
          : undefined;
      case 'PriorityCustomerSupport':
      case 'StatusExclusiveGames':
      case 'DailyWheel':
      case 'VipHost':
        return t(`perkMessage${perkType}`);

      default:
        return;
    }
  }, [perkType, currentStatusPerkAmount, t]);

  return (
    <Box flexDirection="row" alignItems="center" gap="space-100">
      <Text variant="body-m-semi" color="accentSurfacePrimary">
        {perkMessageText}
      </Text>
      {perkType === 'DailyWheel' && currentStatusPerkAmount ? (
        <Box flexDirection="row" alignItems="center" gap="space-100">
          <Icon
            name="bonanzaCoin"
            color="accentSurfacePrimary"
            width={20}
            height={20}
          />
          <Text variant="body-m-semi" color="accentSurfacePrimary">
            {formatCompact(currentStatusPerkAmount)}
          </Text>
        </Box>
      ) : null}
    </Box>
  );
}

export default memo(StatusPerkMessage);
